import "./story.scss";
import { images } from "../../constants";

const Story = () => {
  return (
    <section className="app_story">
      <div className="app_story-cont">
        <div className="app_story-info">
          <h2>Giving Birth Made Easy!</h2>
          <p>
            Entering motherhood is an exciting phase and we at Preggerz want to
            empower women on their journey to become a mother and make the right
            choices by providing them a unified platform for all their products
            and services needs.
          </p>
          <p className='link'>Know Our Story</p>
        </div>
        <div className="app_img-div">
          <img src={images.Story1} alt='story-1'/>
        </div>
      </div>
    </section>
  );
};

export default Story;
